
import axios from "axios";
import {AuthenticationProvider} from "@/modules/shared/bridges/AuthenticationProvider";
import {Authorization} from "@aprocon-software/aprocon-auth-util";
import {B2BAuthRepository} from "@/modules/b2bAuth/adapter/B2BAuthRepository";
import {
    LogonRequest,
    LogonResponseWrapper
} from "@aprocon-software/aprocon-auth-util/dist/services/auth/ServiceModels";

export class B2BAuthRestRepository implements B2BAuthRepository {

    private readonly auth: AuthenticationProvider;

    constructor(auth: AuthenticationProvider) {
        this.auth = auth;
    }

    public async login(userId: string, password: string, deviceId: string, branchId: string = ''): Promise<any> {
        const logonRequest = {
            Email: userId,
            Pass: password
        };
        const response = await axios.post(`${this.serviceUrl()}/Authentication/logonCustomer`, logonRequest);
        const responseData = response.data.logonCustomer_response;
        if (responseData.ServiceErrors && responseData.ServiceErrors.length > 0) {
            const serviceErrors = responseData.ServiceErrors.map((error:any) => ({
                id: error.ERRORNUMBER,
                position: error.ERRORPOSITION,
                recordId: error.ERRORRECORDID,
                description: error.ERRORDESCRIPTION,
                recommendation: error.ERRORRECOMMENDATION,
            }));
            // eslint-disable-next-line no-throw-literal
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            throw { serviceErrors };
        }
        return {
            sid: responseData.SID ,
            userId: responseData.UserID,
            customerId: responseData.CustomerID
        };
    }

    public async logout(): Promise<any> {
        if(this.sid()) {
            const logoutRequest = {
                SID: this.sid(),

            };
            const response = await axios.post(`${this.serviceUrl()}/Authentication/logoffCustomer`, logoutRequest);
            const responseData = response.data.logoff_response;
            if (responseData.ServiceErrors && responseData.ServiceErrors.length > 0) {
                const serviceErrors = responseData.ServiceErrors.map((error: any) => ({
                    id: error.ERRORNUMBER,
                    position: error.ERRORPOSITION,
                    recordId: error.ERRORRECORDID,
                    description: error.ERRORDESCRIPTION,
                    recommendation: error.ERRORRECOMMENDATION,
                }));
                // eslint-disable-next-line no-throw-literal
                // eslint-disable-next-line @typescript-eslint/no-throw-literal
                throw {serviceErrors};
            }
            return {
                success: responseData.Success
            };
        }else {
            return {
                success: false
            };
        }
    }

    public async keepAlive(): Promise<any> {
        const sid = this.sid();
        if(sid) {
            const keepAliveRequest = {
                SID: this.sid()
            };
            const response = await axios.post(`${this.serviceUrl()}/Authentication/KeepAlive`, keepAliveRequest);
            const responseData = response.data.KeepAlive_response;
            if(responseData === null) {
                return true;
            }
            if (responseData.ServiceErrors && responseData.ServiceErrors.length > 0) {
                const serviceErrors = responseData.ServiceErrors.map((error: any) => ({
                    id: error.ERRORNUMBER,
                    position: error.ERRORPOSITION,
                    recordId: error.ERRORRECORDID,
                    description: error.ERRORDESCRIPTION,
                    recommendation: error.ERRORRECOMMENDATION,
                }));
                // eslint-disable-next-line no-throw-literal
                // eslint-disable-next-line @typescript-eslint/no-throw-literal
                throw {serviceErrors};
            }

        }
        return false;
    }
    private serviceUrl() {
        return this.auth.getServiceUrl();
    }

    private sid() {
        return this.auth.getAuthToken();
    }

    private appId() {
        return "APRO.B2B";
    }
}
